export default function hasLetters(value) {
  return typeof value === 'string' && /[a-zA-Z]/.test(value)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/hasLetters.js